<script>
import { Select } from "ant-design-vue";
import { mapGetters } from "vuex";

export default {
    name: "FGDictSelect",
    extends: Select,
    mixins: [
        {
            props: {
                options: {
                    type: Array,
                    required: false,
                    default: () => []
                },
                dictNo: {
                    type: String,
                    required: true
                },
                excludedVals: {
                    type: Array,
                    required: false,
                    default: () => []
                }
            }
        }
    ],
    watch: {
        dictNo: {
            handler() {
                this.updateOptions();
            }
        },
        excludedVals: {
            handler() {
                this.updateOptions();
            },
            deep: true
        }
    },
    methods: {
        ...mapGetters(["getDictData"]),
        updateOptions() {
            this.options.length = 0;
            let dictData = this.getDictData()[this.dictNo];
            if (dictData) {
                dictData
                    .filter((item) => !this.excludedVals.includes(item.value))
                    .forEach((item) => {
                        this.options.push({
                            value: item.value,
                            label: item.text,
                            class: item.cls,
                            style: item.style
                        });
                    });
            }
        }
    },
    created() {
        this.updateOptions();
    }
};
</script>
